import clsx from 'clsx';
import { User } from './types';
import styles from './UserItem.module.css';

type Props = {
  user: User;
};

export default function UserItem({ user }: Props) {
  const positionChange = user.previousPosition - user.position;
  const showMandatoryOptional = user.mandatoryCount >= 0;

  return (
    <div className={styles.container}>
      <div className={styles.positionContainer}>
        <span className={styles.order}>{user.position}</span>
        <span className={styles.gradient} />
      </div>
      <div className={styles.detailsContainer}>
        <div>
          <span className={showMandatoryOptional ? styles.name : styles.nameNoDesc}>{user.alias}</span>
          {
            user.previousPosition !== 0 && positionChange !== 0 ? <span className={clsx(styles.orderChange, {
              [styles.positive]: user.position < user.previousPosition,
              [styles.negative]: user.position > user.previousPosition,
            })}>
              {`${user.position < user.previousPosition ? '↑' : '↓'} ${Math.abs(positionChange)}`}
            </span> : null
          }
        </div>
        {
          (showMandatoryOptional) ? 
        <div className={styles.descriptionContainer}>
          <span className={styles.description}>Mandatory - {user.mandatoryCount}</span>
          <span className={styles.description}>Optional - {user.optionalCount}</span>
        </div>
         : 
         <span/>
        }       
      </div>
      <span className={styles.winnings}>{user.winnings}</span>
    </div>
  );
}
